import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppConfigService, SessionService } from "src/app/core";
import { EventContextService } from "../../events";
import {
  SearchItemResult,
  VisionboardAttributesService,
  VisionboardCategoriesService,
  VisionboardVersionsService,
  VisionboardWorkspaceItemsStoreService,
} from "../../visionboard";
import { VisionboardGlobalItemSearchService } from "../../visionboard/shared";
import { VenueAdminService } from "./venue-admin.service";

@Injectable()
export class VenueAdminInventoryGlobalItemSearchService extends VisionboardGlobalItemSearchService {
  constructor(
    visionboardAttributesService: VisionboardAttributesService,
    visionboardVersionsService: VisionboardVersionsService,
    visionboardCategoriesService: VisionboardCategoriesService,
    visionboardWorkspaceItemsStoreService: VisionboardWorkspaceItemsStoreService,
    protected appConfigService: AppConfigService,
    http: HttpClient,
    eventContextService: EventContextService,
    sessionService: SessionService,
    private _venueAdminService: VenueAdminService,
  ) {
    super(
      visionboardAttributesService,
      visionboardVersionsService,
      visionboardCategoriesService,
      visionboardWorkspaceItemsStoreService,
      appConfigService,
      http,
      eventContextService,
      sessionService,
    );
  }

  protected override getSearchApiUrl(): string {
    return this.appConfigService.getVenueAdminInventoryGlobalSearchUrl(this._venueAdminService.activeVenue.id);
  }

  protected override getVisionboardItems$(
    count: number,
    page: number,
    includeTotalCount: boolean,
    skipVersionCheck?: boolean,
  ): Observable<SearchItemResult> {
    return super.getVisionboardItems$(count, page, includeTotalCount, true);
  }
}
